import './App.css';
import ScrollManager from './components/ScrollManager';

import Footer from './components/Footer/Footer';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import SolutionsCatalogPage from './pages/Solucao/SolutionsCatalogPage';
import SolutionGroupPage from './pages/Solucao/SolutionGroupPage';
import SolutionItemPage from './pages/Solucao/SolutionItemPage';
import { findSolution } from './pages/Solucao/content';
import Eventos from './pages/Eventos/Eventos';
import Home from './pages/Home';
import Blog from './pages/Blog/Blog';
import BlogDetails from './pages/Blog/BlogDetails';
import Cases from './pages/Cases/Cases';
import Produtos from './pages/Produtos/Produtos';
import Sobre from './pages/Sobre/Sobre';
import Contato from './pages/Contato/Contato';
import TermosDeUso from './pages/Legal/TermosDeUso';
import PoliticaDePrivacidade from './pages/Legal/PoliticaDePrivacidade';
import Denuncia from './pages/Denuncia/Denuncia';
import Lgpd from './pages/Legal/Lgpd';
import ConviteEvento from './pages/ConviteEvento/ConviteEvento';
import Registration from './pages/ConviteEvento/Registration';
import ConviteEventoBH from './pages/ConviteEvento/ConviteEventoBH';
import RegistrationBH from './pages/ConviteEvento/RegistrationBH';
import ConviteEventoColombia from './pages/ConviteEvento/ConviteEventoColombia';
import RegistrationColombia from './pages/ConviteEvento/RegistrationColombia';
import ParceiroPedagogico from './pages/ParceiroPedagogico/ParceiroPedagogico';
import ConviteEventoIA from './pages/ConviteEvento/ConviteEventoIA';
import GoogleDay from './pages/ConviteEvento/GoogleDay';
import UniversidadeCalriz from './pages/UniversidadeCalriz/UniversidadeCalriz';
import Regulamento from './pages/UniversidadeCalriz/Regulamento';
import NotFound from './pages/NotFound/NotFound';
import Mapa from './pages/Mapa/Mapa';


// Rota antiga de detalhe: vai para a página do tópico (os ids antigos são os slugs dos tópicos) ou para o catálogo.
function ServiceRedirect() {
  const { serviceId } = useParams();
  const { group } = findSolution(serviceId);
  return <Navigate to={group ? `/solucoes/${group.slug}` : '/solucoes'} replace />;
}

// O catálogo de serviços virou a página Soluções; links antigos para /servicos#id continuam funcionando.
function ServicosRedirect() {
  const { hash } = useLocation();
  return <Navigate to={`/solucoes${hash}`} replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />

          <Route path="/servicos" element={<ServicosRedirect />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/solucoes" element={<SolutionsCatalogPage />} />
          <Route path="/solucoes/:groupSlug" element={<SolutionGroupPage />} />
          <Route path="/solucoes/:groupSlug/:itemSlug" element={<SolutionItemPage />} />
          <Route path="/produtos" element={<Produtos />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="/onde-estamos" element={<Mapa />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/servicos/:serviceId" element={<ServiceRedirect />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />
          <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
          <Route path="/lgpd" element={<Lgpd />} />
          <Route path="/canal-de-denuncias" element={<Denuncia />} />
          <Route path="/best-of-next-goiania" element={<ConviteEvento />} />
          <Route path="/best-of-next-goiania/inscricao" element={<Registration />} />
          <Route path="/best-of-next-bh" element={<ConviteEventoBH />} />
          <Route path="/best-of-next-bh/inscricao" element={<RegistrationBH />} />
          <Route path="/google-para-ciudades-colombia" element={<ConviteEventoColombia />} />
          <Route path="/google-para-ciudades-colombia/inscripcion" element={<RegistrationColombia />} />
          <Route path="/parceiro-pedagogico" element={<ParceiroPedagogico />} />
          <Route path="/universidade-calriz" element={<UniversidadeCalriz />} />
          <Route path="/universidade-calriz/regulamento" element={<Regulamento />} />
          <Route path="/ia-na-pratica-pedagogica" element={<ConviteEventoIA />} />
          <Route path="/google-day-fortaleza" element={<GoogleDay city="Fortaleza" />} />
          <Route path="/google-day-salvador" element={<GoogleDay city="Salvador" />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
